import { Segment, Table } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

import type { FactureType } from '@/types';
import { downloadFacturePdf, grouperLignesParProduit } from '@/utils';
import ModalEncaissementLoocTableBodyRow from './ModalEncaissementLoocTableBodyRow';
import ModalEncaissementLoocTableHeader from './ModalEncaissementLoocTableHeader';
import ModalEncaissementTableBodyRow from './ModalEncaissementTableBodyRow';
import ModalEncaissementTableFooter from './ModalEncaissementTableFooter';
import ModalEncaissementTableHeader from './ModalEncaissementTableHeader';

export interface ModalEncaissementTableProps {
  reste?: number;
  hideFooter?: boolean;
  defaultProduitsMontantsVisible?: boolean;
  factures: FactureType[];
  selected?: number[];
  // Affiche la table en mode LOOC
  looc?: boolean;
  onSelect?: (arg1: boolean, arg2?: number) => void;
}
const ModalEncaissementTable = (props: ModalEncaissementTableProps) => {
  const {
    defaultProduitsMontantsVisible = true,
    reste,
    hideFooter = false,
    factures,
    selected,
    looc = false,
    onSelect,
  } = props;

  // Regroupement des lignes par libellé produit
  const facturesGroupees = React.useMemo(
    () =>
      _.map(factures, (facture) => ({
        ...facture,
        lignes: grouperLignesParProduit(facture.lignes).lignesGroupees,
      })),
    [factures],
  );

  // État de visibilité de la colonne produits et montants
  const [produitsMontants, setProduitsMontants] = React.useState(defaultProduitsMontantsVisible);

  // Fonction pour masquer les produits et montants
  const toggleProduitsMontants = () => setProduitsMontants(!produitsMontants);

  // Nombre de colonnes à fusionner pour le footer
  let colspanFooter = _.size(factures) > 1 ? (produitsMontants ? 6 : 5) : produitsMontants ? 5 : 4;

  colspanFooter = looc ? colspanFooter - 2 : colspanFooter;

  const Header = looc ? ModalEncaissementLoocTableHeader : ModalEncaissementTableHeader;
  const Row = looc ? ModalEncaissementLoocTableBodyRow : ModalEncaissementTableBodyRow;

  return (
    <Segment
      style={{
        padding: 0,
        maxHeight: 350,
        overflowY: 'auto',
      }}
    >
      <Table
        className="encaissement-table"
        celled
        striped
        style={{
          borderTop: 0,
          borderBottom: 0,
          borderLeft: 0,
          tableLayout: 'fixed',
        }}
      >
        <Header
          factures={factures}
          selected={selected}
          produitsMontants={produitsMontants}
          toggleProduitsMontants={toggleProduitsMontants}
          onSelect={onSelect}
        />
        <Table.Body>
          {_.map(facturesGroupees, (facture) => (
            <Row
              nombreFactures={_.size(facturesGroupees)}
              facture={facture}
              selected={selected}
              produitsMontants={produitsMontants}
              onSelect={onSelect}
              onOpenPdf={downloadFacturePdf}
            />
          ))}
        </Table.Body>
        {!hideFooter && (
          <ModalEncaissementTableFooter looc={looc} reste={reste} colspanFooter={colspanFooter} />
        )}
      </Table>
    </Segment>
  );
};

export default ModalEncaissementTable;
